export default "__VITE_ASSET__BYsPTf4$__"